// Generated by scripts/build-ui-icons.mjs.
export { Bell as default } from "../ui/glyphs-1";
